export const getThreads = (state) => state.gmail.threads;
export const getLabels = (state) => state.gmail.labels;
export const getClientStatus = (state) => state.gmail.clientInitialized;
export const getUnreadQuantity = (state) => state.gmail.unreadQuantity;
